module.exports = __webpack_public_path__ + "img/ctrl-t-dagger-1.2790a681.svg";